import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import type { ICellRendererParams } from 'ag-grid-community'
import { Popover } from 'antd'
import React from 'react'

export function InNetworkTermialsCellRenderer(params: ICellRendererParams<T>) {
  if (params?.data?.in_network_terminal_names?.length) {
    const terminals = params.data.only_in_network_terminal_names
    const supplyZones = params.data.in_network_supply_zone_names
    const hasTerminals = terminals?.length > 0
    const hasSupplyZones = supplyZones?.length > 0

    const content = (
      <>
        {hasSupplyZones && <Texto weight='bold'>Supply Zones:</Texto>}
        {supplyZones?.map((supplyZone) => (
          <Texto key={supplyZone}>{supplyZone}</Texto>
        ))}
        {hasTerminals && hasSupplyZones && <br />}
        {hasTerminals && <Texto weight='bold'>Terminals:</Texto>}
        {terminals?.map((terminal) => (
          <Texto key={terminal}>{terminal}</Texto>
        ))}
      </>
    )

    return (
      <Popover content={content} placement='topLeft'>
        <GraviButton buttonText={params?.data?.in_network_terminal_names.length} />
      </Popover>
    )
  }

  return []
}
